var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatlaunch4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8659_2855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.802 17.292C17.802 17.292 17.879 17.237 18.002 17.143C19.845 15.718 21.002 13.653 21.002 11.354C21.002 7.06797 16.972 3.58997 12.002 3.58997C7.03195 3.58997 3.00195 7.06797 3.00195 11.354C3.00195 15.642 7.03195 19 12.002 19C12.426 19 13.122 18.972 14.09 18.916C15.352 19.736 17.194 20.409 18.806 20.409C19.305 20.409 19.54 19.999 19.22 19.581C18.734 18.985 18.064 18.03 17.804 17.291L17.802 17.292Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5C10 16 14 16 16.5 13.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8659_2855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatlaunch4);
export default __webpack_public_path__ + "static/media/chatlaunch-4.0f3786d0e541b6d2b6f220bb53f076d7.svg";
export { ForwardRef as ReactComponent };